blue.ready('resources', '.mixitup', container => {
	const cards = container.querySelector('.cards')
	let catagories = [...cards.querySelectorAll('.card-cat')]

	let mixerMain = mixitup(container, {
		selectors: {
			target: '.card'
		},
  	animation: {
        duration: 250,
        nudge: false,
        reverseOut: false,
        effects: "fade scale(0.01) translateZ(-100px) stagger(40ms)"
    },
		callbacks: {

			onMixStart: function(state, futureState) {

				//console.log("START");
				//console.log(futureState.activeFilter.selector);
			},

			onPaginateStart() {
				
				setTimeout(() => {
					window.scrollTo({
						top: cards.offsetTop - 40,
						behavior: 'smooth'
					})
				});

				let activeButton = document.querySelector('.pagination .mixitup-control-active');
				if (activeButton) {

					let page = activeButton.getAttribute('data-page');
					blue.meth.cookie.set("ListPage", page, "/", 1);
				}
			},
		},
		multifilter: {
			enable: true,
			keyupThrottleDuration: 200
		},
		pagination: {
			limit: 12,
			hidePageListIfSinglePage: true,
			maintainActivePage: true
		},
		templates: {
			pager: '<button type="button" class="pagination-button ${classNames}" data-page="${pageNumber}">${pageNumber}</button>',
			pagerPrev: '<button type="button" class="pagination-button ${classNames}" data-page="prev"></button>',
			pagerNext: '<button type="button" class="pagination-button ${classNames}" data-page="next"></button>',
			pagerTruncationMarker: '<span class="pagination-trunc ${classNames}">&hellip;</span>'
		}
		
	});

	catagories.forEach(cat => cat.addEventListener('click', (e) => {

		e.preventDefault()		

		mixerMain.setFilterGroupSelectors('filters', cat.getAttribute('data-category'))
		mixerMain.parseFilterGroups()
	}))

	let filters = "";
	let prefilter = document.querySelector('[data-prefilter]');
	if (prefilter) { 

		filters = prefilter.getAttribute('data-prefilter');
	
	} else {

		filters = blue.meth.cookie.get("ListFilter");
	}

	if (filters && filters !== "") {

		let activeFilters = "";
		let filterList = filters.split(',');

		// verify each filter exits on current page
		for (var i=0; i<filterList.length; i++) {
			var filterElement = document.querySelector("[data-toggle='" + filterList[i] + "']");
			if (filterElement) {

				activeFilters += filterList[i] + ",";

			} 
		}

		filters = activeFilters.replace(/,\s*$/, "");
	}

	if (filters && filters !== "") {

		mixerMain.setFilterGroupSelectors('filters', filters.split(','));
		mixerMain.parseFilterGroups();
	} 

	let currentPage = blue.meth.cookie.get("ListPage");
	if (!currentPage) currentPage = 1;
	mixerMain.paginate(currentPage);
	
})